export const ActionTypes = {
  FETCH_ALL: 'services/tool/fetch_all',
  FETCH_ALL_SUCCESS: 'services/tool/fetch_all_success',
  FETCH_TOOL_BY_ID: 'services/tool/fetch_tool_by_id',
  TOOL_EXPORT_BY_FACTORY_NAME: 'services/tool/export_by_factory_name',
  SET_TOOL_EXPORT_BY_FACTORY_LOADER: 'services/tool/set_by_factory_loader',
  SET_TOOL_EXPORT_BY_FACTORY: 'services/tool/set_by_factory_data',
  EXPORT_TOOL_DATA: 'services/tool/export_tool_data',
  EXPORT_TOOL_DATA_LOADER: 'services/tool/export_tool_data_loader',
  SET_EXPORT_TOOL_DATA: 'services/tool/set_export_tool_data',
  SET_TOOL_BY_ID: 'services/tool/set_tool_by_id',
  SET_LOADER_STATUS: 'services/tool/set_loader_status',
  SET_ALL: 'services/tool/set_all',
  FETCH_TOOLS_DATA: 'services/tool/fetch_tools_data',
  SET_TOOLS_DATA: 'services/tool/set_tools_data',
  ADD_OR_UPDATE_TOOL: 'services/tool/add_or_update_tool',
  DELETE_TOOL: 'services/tool/delete_tool',
  FETCH_TOOLS_BY_FACTORYID: 'services/tool/fetch_tools_by_factoryId',
  SET_TOOLS_BY_FACTORYID: 'services/tool/set_tools_by_factoryId',
  SET_IMPORT_EXCEL_TOOL_FILE: 'services/tool/set_import_excel_tool_file',
  SET_IMPORT_EXCEL_TOOL_FILE_LOADER_STATUS: 'services/tool/set_import_excel_tool_file_loader_status',
  TOOL_IMPORT: 'services/tool/tool_import',

  IS_TOOL_DELETABLE: 'services/tool/is_tool_deletable',
  SET_TOOL_DELETABLE: 'services/tool/set_tool_deletable',
  SET_TOOL_DELETABLE_LOADER_STATUS: 'services/tool/set_tool_deletable_loader_status',

  FETCH_ALL_TOOL_DATA_LOADER: 'services/tool/fetch_all_tool_data_loader',
};

const fetchAll = ({ toolParams }) => ({
  toolParams,
  type: ActionTypes.FETCH_ALL,
});

const fetchToolsData = () => ({
  type: ActionTypes.FETCH_TOOLS_DATA,
});

const setToolsData = ({ toolsData }) => ({
  toolsData,
  type: ActionTypes.SET_TOOLS_DATA,
});

// export complete tool data in csv call
const toolDataExport = () => ({
  type: ActionTypes.EXPORT_TOOL_DATA,
});

// export tool data loader
const toolDataExportLoader = ({ toolExportLoader }) => ({
  toolExportLoader,
  type: ActionTypes.EXPORT_TOOL_DATA_LOADER,
});

// set export tool data
const setToolDataExport = ({ toolExportData }) => ({
  toolExportData,
  type: ActionTypes.SET_EXPORT_TOOL_DATA,
});

const fetchToolById = ({ toolId }) => ({
  toolId,
  type: ActionTypes.FETCH_TOOL_BY_ID,
});

const setToolById = ({ tool }) => ({
  tool,
  type: ActionTypes.SET_TOOL_BY_ID,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const setAll = ({ allTool }) => ({
  allTool,
  type: ActionTypes.SET_ALL,
});

const addorUpdateTool = ({ toolData, actionName, toolParams }) => ({
  toolData,
  actionName,
  toolParams,
  type: ActionTypes.ADD_OR_UPDATE_TOOL,
});

const deleteTool = ({ id, toolParams }) => ({
  id,
  toolParams,
  type: ActionTypes.DELETE_TOOL,
});

const fetchToolByFactoryId = ({ factoryId }) => ({
  factoryId,
  type: ActionTypes.FETCH_TOOLS_BY_FACTORYID,
});

const setToolByFactoryId = ({ getToolDataByFactoryId }) => ({
  getToolDataByFactoryId,
  type: ActionTypes.SET_TOOLS_BY_FACTORYID,
});

const isToolDeletable = ({ toolId }) => ({
  toolId,
  type: ActionTypes.IS_TOOL_DELETABLE,
});

const setToolDeletable = ({ toolDeletable }) => ({
  toolDeletable,
  type: ActionTypes.SET_TOOL_DELETABLE,
});

const setToolDeletableLoader = ({ toolDeletableLoader }) => ({
  toolDeletableLoader,
  type: ActionTypes.SET_TOOL_DELETABLE_LOADER_STATUS,
});

const importExcelToolFile = ({ importFileParams, toolParams }) => ({
  importFileParams,
  toolParams,
  type: ActionTypes.TOOL_IMPORT,
});

const setImportExcelToolFile = ({ importToolFile }) => ({
  importToolFile,
  type: ActionTypes.SET_IMPORT_EXCEL_TOOL_FILE,
});

const setImportExcelToolFileLoader = ({ importExcelFileLoader }) => ({
  importExcelFileLoader,
  type: ActionTypes.SET_IMPORT_EXCEL_TOOL_FILE_LOADER_STATUS,
});
//--------------------------------------- tool export file by factory name actions

const toolExportByFactoryName = ({ toolExportParams }) => ({
  toolExportParams,
  type: ActionTypes.TOOL_EXPORT_BY_FACTORY_NAME,
});
const setToolExportFactoryLoader = ({ toolExportByFactoryLoader }) => ({
  toolExportByFactoryLoader,
  type: ActionTypes.SET_TOOL_EXPORT_BY_FACTORY_LOADER,
});
const setToolExportFactoryData = ({ toolExportByFactoryNameData }) => ({
  toolExportByFactoryNameData,
  type: ActionTypes.SET_TOOL_EXPORT_BY_FACTORY,
});

const setAllToolsDataLoader = ({ allToolsDataLoader }) => ({
  allToolsDataLoader,
  type: ActionTypes.FETCH_ALL_TOOL_DATA_LOADER,
});

export default {
  fetchAll,
  toolExportByFactoryName,
  setToolExportFactoryLoader,
  setToolExportFactoryData,
  fetchToolById,
  setToolById,
  setAll,
  toolDataExport,
  toolDataExportLoader,
  setToolDataExport,
  fetchToolsData,
  setToolsData,
  setLoader,
  addorUpdateTool,
  deleteTool,
  fetchToolByFactoryId,
  setToolByFactoryId,
  isToolDeletable,
  setToolDeletable,
  importExcelToolFile,
  setToolDeletableLoader,
  setImportExcelToolFile,
  setImportExcelToolFileLoader,
  setAllToolsDataLoader,
};
